// ** Logo
import { Spinner } from "reactstrap";

const SpinnerComponent = ({ contained = false }) => {
  return (
    <div className={`page-spinner${contained ? "" : " page-spinner-screen"}`}>
      <Spinner color="primary" />
    </div>
  );
};

export default SpinnerComponent;
